<template>
    <div class="register_phone">
        <el-dialog custom-class="register_phone" title="企业邮箱登录" :visible.sync="showRgister" :close-on-click-modal="false">
            <el-form :model="registerForm" ref="registerForm" :rules="rules" v-loading="loading"
                element-loading-text="验证码发送中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.6)">
                <el-form-item class="email" prop="email">
                    <el-input v-model.trim="registerForm.email"  @keyup.native="registerForm.email = registerForm.email.toLocaleLowerCase()" clearable placeholder="请输企业邮箱"></el-input>
                    <div class="sendCode">
                        <span @click="sendCode" v-show="status == 1">点击发送验证码</span>
                        <span v-show="status == 2">{{ second }}S</span>
                        <span @click="sendCode" v-show="status == 3">点击重新发送</span>
                    </div>
                </el-form-item>
                <el-form-item prop="code">
                    <el-input v-model.trim="registerForm.code" placeholder="请输入验证码" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button style="width:100%" @click="submitForm('registerForm')" type="primary">登录</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
  
<script>
import {
    format, bignumber, multiply
} from 'mathjs'

import ElScrollbar from 'element-ui/lib/scrollbar';
// import htsNumber  from '@/assets/json/htsNumber.json'
export default {
    name: 'my-main',
    components: {
        ElScrollbar,
        // el-icon-warning
    },
    data: function () {
        var validateEmail = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入企业邮箱'));
            } else {
                if (!this.isEmail(value)) {
                    callback(new Error('邮箱格式错误'));
                } else if (this.isEnterpriseEmail(value)) {
                    callback(new Error('请输入企业邮箱,暂不支持163、qq、outlook等常用邮箱'));
                }
                callback();
            }
        };
        var validateCode = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入验证码'));
            } else {
                if (this.registerForm.code.length < 6) {
                    callback(new Error('验证码为6位'));
                }
                callback();
            }
        };
        return {
            showRgister: false,
            registerForm: {
                email: "",
                code: "",
            },
            second: 120,
            status: 1,
            comfirmCode: "",
            loading: false,
            rules: {
                email: [
                    { required: true, validator: validateEmail, trigger: 'blur' },

                ],
                code: [
                    { required: true, validator: validateCode, trigger: 'blur' }
                ],
            }
        }
    },
    created() {

    },
    methods: {
        setCookie(email) {
            if (!this.$Cookie.get('user_email'))
                this.$Cookie.set('user_email', email)
            console.log('setCookie', this.$Cookie.get('user_email'));
        },
        showRegister() {
            this.showRgister = true
        },
        checkCode() {
            this.$http.get(`/user/checkMailVerificationCode?mail=${this.registerForm.email}&code=${this.registerForm.code}`)
                .then((res) => {
                    this.$message({
                        message: "登录成功",
                        type: 'success',
                        customClass: "phone"
                    });
                    this.setCookie(this.registerForm.email)
                    this.showRgister = false
                }).catch((err) => {

                })
        },
        sendCode() {
            this.$refs.registerForm.validateField('email')
            if (this.isEmail(this.registerForm.email) && !this.isEnterpriseEmail(this.registerForm.email)) {
                this.loading = true
                this.$http.get(`/user/sendMailVerificationCode?mail=${this.registerForm.email}`)
                    .then((res) => {
                        this.loading = false
                        this.$message({
                            message: "发送成功",
                            type: 'success',
                            customClass: "phone"
                        });
                        this.status = 2
                        let seconds = setInterval(() => {
                            this.second = this.second - 1
                            if (this.second == 0) {
                                this.status = 3
                                this.second = 60
                                clearInterval(seconds)
                            }
                        }, 1000)
                    }).catch((err) => {

                    })
            }

        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.checkCode()
                } else {

                    return false;
                }
            });
        },
        isEnterpriseEmail(email) {
            var pattern = /@(163|126|qq|foxmail|sina|sohu|139|189|263|yeah|hotmail|outlook|office365)\.(com|cn|net)$/i;
            return pattern.test(email);
        },
        isEmail(str) {
            var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
            return reg.test(str);
        }
    },
    mounted() {
        // this.calPrice()


    },
}
</script>
<style scoped>
.register_phone .el-dialog__body {
    padding-bottom: 20px;
}

.sendCode {
    position: absolute;
    top: 0px;
    right: 30px;
    color: #005bab;
    cursor: pointer;
}

.sendCode span {
    height: 100%;
    display: block;
}
</style>
 